// find-my-size.js

(function () {
  var TOPS_CHART = [
    { size: 'XS',  bustMin: 30, bustMax: 32, waistMin: 23, waistMax: 26 },
    { size: 'S',   bustMin: 34, bustMax: 36, waistMin: 26, waistMax: 28 },
    { size: 'M',   bustMin: 36, bustMax: 38, waistMin: 30, waistMax: 32 },
    { size: 'L',   bustMin: 38, bustMax: 40, waistMin: 32, waistMax: 34 },
    { size: 'XL',  bustMin: 40, bustMax: 42, waistMin: 34, waistMax: 36 },
    { size: '2XL', bustMin: 42, bustMax: 44, waistMin: 38, waistMax: 40 },
    { size: '3XL', bustMin: 44, bustMax: 46, waistMin: 40, waistMax: 42 },
  ];

  var BREECHES_CHART = [
    { size: 'XS',  waistMin: 23,   waistMax: 26,   hipMin: 33, hipMax: 36 },
    { size: 'S',   waistMin: 26,   waistMax: 28,   hipMin: 37, hipMax: 38 },
    { size: 'M',   waistMin: 28.5, waistMax: 30.5, hipMin: 39, hipMax: 40 },
    { size: 'L',   waistMin: 31,   waistMax: 34,   hipMin: 41, hipMax: 43 },
    { size: 'XL',  waistMin: 34.5, waistMax: 37,   hipMin: 44, hipMax: 46 },
    { size: '2XL', waistMin: 38,   waistMax: 41,   hipMin: 48, hipMax: 50 },
    { size: '3XL', waistMin: 42,   waistMax: 45,   hipMin: 51, hipMax: 53 },
  ];

  // ─── Size logic ──────────────────────────────────────────────────
  function findSize(value, chart, minKey, maxKey) {
    var matches = [];
    for (var i = 0; i < chart.length; i++) {
      if (value >= chart[i][minKey] && value <= chart[i][maxKey]) {
        matches.push(chart[i].size);
      }
    }
    if (matches.length === 1) return { size: matches[0] };
    if (matches.length > 1)  return { size: matches[0] + '/' + matches[1] };
    for (var i = 0; i < chart.length - 1; i++) {
      if (value > chart[i][maxKey] && value < chart[i + 1][minKey]) {
        return { size: chart[i].size + '/' + chart[i + 1].size };
      }
    }
    if (value < chart[0][minKey]) return { size: chart[0].size };
    if (value > chart[chart.length - 1][maxKey]) return { size: chart[chart.length - 1].size };
    return { size: chart[0].size };
  }

  function getRecommendation(m1, m2, isBreeches) {
    var chart = isBreeches ? BREECHES_CHART : TOPS_CHART;
    var r1 = isBreeches
      ? findSize(m1, chart, 'waistMin', 'waistMax')
      : findSize(m1, chart, 'bustMin',  'bustMax');
    var r2 = isBreeches
      ? findSize(m2, chart, 'hipMin',   'hipMax')
      : findSize(m2, chart, 'waistMin', 'waistMax');

    var combined = [];
    r1.size.split('/').concat(r2.size.split('/')).forEach(function (s) {
      if (combined.indexOf(s) === -1) combined.push(s);
    });
    var order = chart.map(function (r) { return r.size; });
    combined.sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });
    return {
      size: combined.join('/'),
      note: combined.length > 1 ? 'Size down for a structured fit, size up for more room.' : '',
    };
  }

  function buildOptions(min, max, placeholder) {
    var html = '<option value="">' + placeholder + '</option>';
    for (var i = min; i <= max; i++) {
      html += '<option value="' + i + '">' + i + '"</option>';
    }
    return html;
  }

  // ─── Modal ───────────────────────────────────────────────────────
  function openModal() {
    var modal = document.getElementById('faimus-size-modal');
    if (!modal) return;
    modal.style.display = 'flex';
    document.getElementById('faimus-screen-input').style.display = 'block';
    document.getElementById('faimus-screen-result').style.display = 'none';
    document.getElementById('faimus-m1').value = '';
    document.getElementById('faimus-m2').value = '';
    document.getElementById('faimus-find-btn').classList.remove('faimus-active');
  }

  function closeModal() {
    var modal = document.getElementById('faimus-size-modal');
    if (modal) modal.style.display = 'none';
  }

  function init() {
    var modal = document.getElementById('faimus-size-modal');
    if (!modal) return;

    var isBreeches = modal.dataset.type === 'breeches';

    // Populate labels + selects
    document.getElementById('faimus-label1').textContent = isBreeches ? 'WAIST (in.)' : 'BUST (in.)';
    document.getElementById('faimus-label2').textContent = isBreeches ? 'HIP (in.)'   : 'WAIST (in.)';
    document.getElementById('faimus-m1').innerHTML = isBreeches
      ? buildOptions(23, 45, 'Select Waist')
      : buildOptions(30, 46, 'Select Bust');
    document.getElementById('faimus-m2').innerHTML = isBreeches
      ? buildOptions(33, 53, 'Select Hip')
      : buildOptions(23, 42, 'Select Waist');

    var m1Select = document.getElementById('faimus-m1');
    var m2Select = document.getElementById('faimus-m2');
    var findBtn  = document.getElementById('faimus-find-btn');

    m1Select.addEventListener('change', function () {
      findBtn.classList.toggle('faimus-active', !!(m1Select.value && m2Select.value));
    });
    m2Select.addEventListener('change', function () {
      findBtn.classList.toggle('faimus-active', !!(m1Select.value && m2Select.value));
    });

    // Triggers — event delegation so re-rendered buttons still work
    document.addEventListener('click', function (e) {
      if (e.target.closest('.faimus-find-my-size-trigger')) {
        e.preventDefault();
        openModal();
      }
    });

    // Close
    modal.querySelector('.faimus-size-overlay').addEventListener('click', closeModal);
    modal.querySelector('.faimus-size-close').addEventListener('click', closeModal);
    document.getElementById('faimus-close-result').addEventListener('click', closeModal);
    document.getElementById('faimus-back-btn').addEventListener('click', function () {
      document.getElementById('faimus-screen-result').style.display = 'none';
      document.getElementById('faimus-screen-input').style.display = 'block';
    });

    // Find
    findBtn.addEventListener('click', function () {
      if (!this.classList.contains('faimus-active')) return;
      var m1 = parseFloat(m1Select.value);
      var m2 = parseFloat(m2Select.value);
      if (!m1 || !m2) return;
      var rec = getRecommendation(m1, m2, isBreeches);
      document.getElementById('faimus-result-size').textContent = rec.size;
      document.getElementById('faimus-result-note').textContent = rec.note;
      document.getElementById('faimus-screen-input').style.display = 'none';
      document.getElementById('faimus-screen-result').style.display = 'block';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
